import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MockTransactionDualApprovalService } from 'src/app/fednow/service/mock/mock.transaction-dual-approval.service';

@Injectable({
  providedIn: 'root',
})
export class MockRtpTransactionDualApprovalService extends MockTransactionDualApprovalService {
  protected override tableFilterJson = 'assets/mocks/rtp/dual-approval/tableFilter.json';
  protected override getSummaryJson = 'assets/mocks/rtp/dual-approval/getSummary.json';

  constructor(http: HttpClient) {
    super(http);
  }
}
